import { render, staticRenderFns } from "./CollectDelayDaysChip.vue?vue&type=template&id=bd957a94&scoped=true"
import script from "./CollectDelayDaysChip.vue?vue&type=script&lang=js"
export * from "./CollectDelayDaysChip.vue?vue&type=script&lang=js"
import style0 from "./CollectDelayDaysChip.vue?vue&type=style&index=0&id=bd957a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd957a94",
  null
  
)

export default component.exports